export default __webpack_public_path__ + "static/media/resume.af9c260f.png";